import { DataTestId as UIDataTestId } from "@iyk/music-ui/data-test-id"

export namespace DataTestId {
  export const breadcrumbs = "breadcrumbs"
  export const breadcrumbItem = "breadcrumb-item"

  export const submitButton = "submit"
  export const cancelButton = "cancel"
  export const saveAndExitButton = "save-and-exit"
  export const backButton = "back"

  export const worldLinksAddLinkButton = "add-link"
  export const worldLinksRemoveLinkButton = (index: number) => `remove-link-${index}`
  export const worldLinksLinkInput = (index: number) => `link-input-${index}`
  export const worldPoliciesPrivacyPolicyUrlInput = "privacy-policy-url"

  export const emailInput = "email"
  export const nameInput = "name"
  export const slugInput = "slug"
  export const titleInput = "title"

  export const resendOtp = "resend-otp"

  export const optInEmailMarketing = "opt-in-email-marketing"

  export const logoutAction = "logout"

  export const userMenu = UIDataTestId.userMenu
  export const userMenuLogout = UIDataTestId.userMenuLogout
  export const menuButtonMobile = "menu-button-mobile"

  export const worldAvatarInput = "world-avatar-input"
  export const worldAvatarImage = "world-avatar-image"

  export const worldBannerInput = "world-banner-input"
  export const worldBannerImage = "world-banner-image"
  export const worldIdImageInput = "world-id-image-input"

  export const worldGetStartedBtn = "world-get-started-btn"
  export const worldCompleteOnboardingBtn = "world-complete-onboarding-btn"

  export const detailActionMenuButton = "detail-action-menu-button"
  export const detailDeleteButton = "detail-delete-button"
  export const detailDeleteSubmitButton = "detail-delete-submit-button"
  export const detailEditButtonMobile = "detail-edit-button-mobile"
  export const detailEditButtonDesktop = "detail-edit-button-desktop"

  export const productPrimaryMediaInput = "product-primary-media-input"
  export const productPrimaryMediaImage = "product-primary-media-image"
  export const productName = "product-name"

  export const unlockMediaInput = "unlock-media-input"
  export const unlockMediaValue = "unlock-media-value"
  export const unlockChooseDialogButton = "unlock-choose-dialog-button"
  export const unlockChooseDialogContentButton = "unlock-choose-dialog-content-button"
  export const unlockTitle = "unlock-title"
}
